export default function initBlockInView() {

  const blocks = document.querySelectorAll('[data-block-animate]');
  let animatedCount = 0;
  const total = blocks.length;

  if (!total) {
    document.body.classList.remove('is-loading');
    return;
  }

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
        obs.unobserve(entry.target);

        animatedCount++;

        if (animatedCount === total) {
          document.body.classList.remove('is-loading');
        }
      }
    });
  }, {
    threshold: 0.1
  });

  blocks.forEach(el => observer.observe(el));
}
